module.exports = __webpack_public_path__ + "static/logos/icon-telegram-a90f89a06f6136783593d7918435f1a1.svg";